import React from 'react'

import { useTranslation } from "react-i18next";

import questions_kor from "./FAQ.json";
import questions_eng from "./FAQ_eng.json";
import Banner from "../../Components/Banner/Banner";

const FAQContent = () => {
  const { t } = useTranslation();

  return (
    <div className='mid-section-wrap-02'>
      {
        t("lang") == "ko"
        ?
        <Banner className="mid-section-cnt">
        <Banner.Header className="sect-08-tit-01 sect-tit">자주 묻는 질문</Banner.Header>
        {questions_kor.map((question) => (
        <Banner.Entity key={question.id}>
            <Banner.Question>{question.question}</Banner.Question>
            <Banner.Text>{question.answer}</Banner.Text>
        </Banner.Entity>
        ))}
        </Banner>
        :
        <Banner>
        <Banner.Header>FAQ</Banner.Header>
        {questions_eng.map((question) => (
        <Banner.Entity key={question.id}>
            <Banner.Question>{question.question}</Banner.Question>
            <Banner.Text>{question.answer}</Banner.Text>
        </Banner.Entity>
        ))}
        </Banner>
      }

    </div>
  )
}

export default FAQContent